<template>

	<div class="landing-internalError">
		<section class="container-fluid" v-in-viewport="" v-for="errors in errorPage">
			<div class="text-center headline-container">  
		  	 	<h1 class="headline" v-in-viewport="">{{ errors.elements.n500.value }} </h1>
		 	</div>
		</section>
	</div>

</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';


	export default{
		name: 'NotFound',
		data () {
		   return {
		   		errorPage:[]
		   }
		},
		created(){
			this.getErrorsPage();
		},

		mixins:[apiConnection]


	}
</script>


// WEBPACK FOOTER //
// InternalError.vue?ccda21f4